import {
    curriculum_create_Api,
    curriculum_createCourseFrom_Api,
    curriculum_delete_Api,
    curriculum_edit_Api,
    curriculum_editSubjectParam_Api,
    curriculum_linkSubject_Api,
    curriculum_unlinkSubject_Api,
} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify} from 'views/AppLocals/factory/createNotification'
import {NullAsDefault} from 'views/Shared'

export const useCurriculum = ({
    onCreated = NullAsDefault,
    onUpdated = NullAsDefault,
    onDeleted = NullAsDefault,
    onLinked = NullAsDefault,
    onUnlinked = NullAsDefault,
    onSubjectParamUpdated = NullAsDefault,
    onCourseCreated = NullAsDefault,
    autoRefresh = true,
} = {}) => {
    const t = useTranslate()
    const [refreshKey, setRefreshKey] = useState()

    const onError = notifyOnError(t)

    const onRefresh = () => {
        if (autoRefresh) setRefreshKey(Date.now())
    }

    const {handleAsyncAction: onCreate} = useAsyncAction({
        apiInfo: curriculum_create_Api,
        onError,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onRefresh()
            onCreated(...args)
        },
    })

    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: curriculum_edit_Api,
        onError,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRefresh()
            onUpdated(...args)
        },
    })

    const {handleAsyncAction: onDelete} = useAsyncAction({
        apiInfo: curriculum_delete_Api,
        onError,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onRefresh()
            onDeleted(...args)
        },
    })

    const {handleAsyncAction: onLinkSubject} = useAsyncAction({
        apiInfo: curriculum_linkSubject_Api,
        onError,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRefresh()
            onLinked(...args)
        },
    })

    const {handleAsyncAction: onUnlinkSubject} = useAsyncAction({
        apiInfo: curriculum_unlinkSubject_Api,
        onError,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onRefresh()
            onUnlinked(...args)
        },
    })

    const {handleAsyncAction: onUpdateSubjectParam} = useAsyncAction({
        apiInfo: curriculum_editSubjectParam_Api,
        onError,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRefresh()
            onSubjectParamUpdated(...args)
        },
    })

    const {handleAsyncAction: onCreateCourse} = useAsyncAction({
        apiInfo: curriculum_createCourseFrom_Api,
        onError,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onRefresh()
            onCourseCreated(...args)
        },
    })

    return {
        onCreate,
        onUpdate,
        onDelete,
        onLinkSubject,
        onUnlinkSubject,
        onUpdateSubjectParam,
        onCreateCourse,
        onRefresh,
        refreshKey,
    }
}
